/**
 * Sanitizes a sort field value to prevent SQL injection.
 * Only allows alphanumeric characters, underscores, dots, and hyphens.
 */
export function sanitizeSortField(sortField: string): string {
    return sortField.replace(/[^a-zA-Z0-9_.-]/g, '');
}
